import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { useState } from 'react';
import { RulesEngineFormValues } from '../rules-engine-form-page';
import UsersAutocomplete from '../../../../shared/users-autocomplete';
import AvatarChip from '../../../../shared/avatar-chip';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

interface AllSourceOptionsProps {
  control: Control<RulesEngineFormValues>;
  watch: UseFormWatch<RulesEngineFormValues>;
  setValue: UseFormSetValue<RulesEngineFormValues>;
  handleAddAllUsersChecked: (value: boolean) => void;
}

export default function AllSourceOptions({
  control,
  watch,
  setValue,
  handleAddAllUsersChecked,
}: AllSourceOptionsProps) {
  const allSource = watch('allSource');
  const targetsExcluded = watch('targetsExcluded');

  const [autoCompleteExcludeResponse, setAutoCompleteExcludeResponse] =
    useState('');

  return (
    <Stack sx={{ mt: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={allSource}
            onChange={(e) => handleAddAllUsersChecked(e.target.checked)}
          />
        }
        label="Add all users"
      />
      <Box>
        <Controller
          name={'targetsExcluded'}
          control={control}
          render={({ field }) => (
            <UsersAutocomplete
              autocompleteValue={autoCompleteExcludeResponse}
              setAutoCompleteValue={(value) => {
                setAutoCompleteExcludeResponse(value ?? '');
                if (!value) return;
                const currentExcluded = field.value ?? [];
                if (!currentExcluded.includes(value)) {
                  field.onChange([...currentExcluded, value]);
                }
                setTimeout(() => setAutoCompleteExcludeResponse(''), 0);
              }}
              disabled={!allSource}
              label="Users to Exclude"
            />
          )}
        />
        <Stack direction="row" flexWrap="wrap" sx={{ mt: 1, mb: 2 }}>
          {targetsExcluded?.map((user) => (
            <AvatarChip
              key={user}
              label={user}
              type={'User'}
              email={user}
              onDelete={() => {
                const currentExcluded = watch('targetsExcluded') ?? [];
                setValue(
                  'targetsExcluded',
                  currentExcluded.filter(
                    (excludedUser) => excludedUser !== user
                  ),
                  { shouldValidate: true }
                );
              }}
            />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
